/**
 * Suppresses the Orbe localization recommendation after a country and language
 * have already been selected. The app reads these cookie names directly.
 */
document.addEventListener('DOMContentLoaded', () => {
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  const hasCountry = getCookie('mdApp_countryCodeDomain');
  const hasLanguage = getCookie('mdApp_showRecommendationLang');
  const hasModalTime = getCookie('mdApp_cookieModalTime');

  if (hasCountry && hasLanguage && !hasModalTime) {
    if (window.orbito && typeof window.orbito.closeModal === 'function') {
      window.orbito.closeModal('md-app-embed__modal');
    }

    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 7);
    document.cookie =
      'mdApp_cookieModalTime=' +
      Date.now() +
      '; expires=' +
      expiry.toUTCString() +
      '; path=/; domain=neutrlspaceny.com';
  }
});
